import { apiSlice } from '../../api/apiSlice';
import { SimLocationsResponse } from './simLocationsApiSliceTypes';
import { DashboardParams } from '../dashboardTypes';
import { serializeQueryParams } from '../index';

const simLocationsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSimLocations: builder.query<SimLocationsResponse, DashboardParams>({
            query: (params) => ({
                url: `/dashboard/sim-locations?${serializeQueryParams(params)}`,
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetSimLocationsQuery, useLazyGetSimLocationsQuery } =
    simLocationsApiSlice;
